<template>
  <div>
    <div class="row">
      <div class="col-md-3 mb-3">
        <anosafra-multiselect
          v-model="filter.anoSafra"
          label="Ano Safra"
          filterable
        />
      </div>
      <div class="col-md-3">
        <label class="form-control-label">Gerente Comercial</label>
        <multiselect
          :placeholder="'Escolha um Gerente Comercial'"
          v-if="currentUser.is_admin"
          v-model="filter.manager"
          :select-label="''"
          :deselect-label="''"
          :selected-label="'Selecionado'"
          filterable
          :loading="isLoadingManagers"
          :searchable="true"
          :close-on-select="true"
          :options="managers"
          @search-change="getManagers"
          label="name"
          track-by="id"
        >
        </multiselect>
        <base-input
          v-else-if="currentUser.is_manager"
          :value="currentUser.name"
          :disabled="true"
        ></base-input>
        <base-input
          v-else-if="currentUser.is_salesman"
          :value="currentUser.manager.name"
          :disabled="true"
        ></base-input>
      </div>
      <div class="col-md-3">
        <label class="form-control-label">Vendedor</label>
        <multiselect
          v-model="filter.salesman"
          filterable
          :searchable="true"
          :close-on-select="true"
          :options="salesmen"
          :select-label="''"
          :deselect-label="''"
          :selected-label="'Selecionado'"
          label="name"
          track-by="id"
          :allow-empty="true"
          :disabled="!currentUser.is_admin && !currentUser.is_manager"
          group-label="descricao"
          placeholder="Escolha um vendedor"
          :loading="isLoadingSalesmen"
          @search-change="findSalesmen"
        ></multiselect>
      </div>
      <div class="col-md-3">
        <label class="form-control-label">Filial</label>
        <multiselect
          v-model="filter.branch"
          filterable
          :searchable="true"
          :close-on-select="true"
          :options="branches"
          placeholder="Escolha uma Filial"
          :select-label="''"
          :deselect-label="''"
          :selected-label="'Selecionado'"
          label="name"
          track-by="id"
        ></multiselect>
      </div>
      <div class="col-md-3">
        <label class="form-control-label">Tipo de Vendedor</label>
        <multiselect
          v-model="filter.type"
          filterable
          :searchable="true"
          :close-on-select="true"
          :options="types"
          placeholder="Tipo de Vendedor"
          :select-label="''"
          :deselect-label="''"
          :selected-label="'Selecionado'"
          label="name"
          track-by="code"
        ></multiselect>
      </div>
      <div class="col-md-3">
        <label class="form-control-label">Segmento</label>
        <multiselect
          v-model="filter.channel"
          filterable
          :searchable="true"
          :close-on-select="true"
          :options="channels"
          placeholder="Tipo de Segmento"
          :select-label="''"
          :deselect-label="''"
          :selected-label="'Selecionado'"
          label="description"
          track-by="id"
        ></multiselect>
      </div>
    </div>
    <div slot="footer" class="row justify-content-end mr-1">
      <base-button
        type="secondary"
        class="mr-2 mt-2"
        @click="clearFilters">
        Limpar Filtros
      </base-button>
      <base-button
        type="primary"
        class="mr-2 mt-2"
        @click="onSubmit"><i class="fas fa-filter"></i>
        Filtrar
      </base-button>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import Multiselect from "@/components/Multiselect/translated_multiselect.vue";
import AnosafraMultiselect from "@/components/Multiselect/anosafra_multiselect.vue";


import { Select, Option, Loading } from "element-ui";
export default {
  name: "filters",
  components: {
    Multiselect,
    AnosafraMultiselect,
    [Select.name]: Select,
    [Option.name]: Option,
  },
  data() {
    return {
      active: true,
      filter: {
        manager: {},
        anoSafra: {},
        salesman: {},
      },
      currentUser: {},
      errors: [],
      managers: [],
      filteredSalesmen: [],
      anosafras: [],
      branches: [],
      channels: [],
      salesmen: [],
      lastSalesmenRequestTimestamp: 0,
      lastManagerRequestTimestamp: 0,
      types: [
        { code: "campo", name: "Campo" },
        { code: "balcao", name: "Balcão" },
        { code: "redistribuicao", name: "Redistribuição" },
      ],
      isLoadingManagers: true,
      isLoadingSalesmen: true,
    };
  },
  mounted() {
    this.getBranches();
    this.currentUser = this.$currentUser();
    this.getChannels();

    if (this.currentUser.is_admin) {
      this.getManagers();
    } else if (
      this.currentUser.is_manager ||
      this.currentUser.has_coordinateds
    ) {
      this.filter.managers = [this.currentUser];
      this.filter.salesmans = this.currentUser.salesmans;
      this.filter.manager = this.currentUser;
    } else if (this.currentUser.is_salesman) {
      this.filter.managers = [this.currentUser.manager];
      this.filter.salesmans = [this.currentUser];
      this.filter.manager = this.currentUser.manager;
      this.filter.salesman = this.currentUser;
    }

    if (this.$can("index", "user")) {
      this.findSalesmen("");
    }
  },
  methods: {
    clearFilters(){
      this.filter.manager = "";
      this.filter.salesman = "";
      this.filter.branch = "";
      this.filter.type = "";
      this.filter.channel = "";
    },
    onSubmit(){
      this.getManagers();
      this.findSalesmen();
      this.getBranches();
      this.getChannels();
    },
    setError(error, text) {
      console.error("[Filters][setError]", error)
      this.error =
        (error.response && error.response.data && error.response.data.error) ||
        text;
    },
    getBranches() {
      this.$http.secured
        .get(`/api/v1/branches/`)
        .then((response) => {
          this.branches = response.data;
        })
        .catch((error) => this.setError(error, "Something went wrong"));
    },
    async getManagers(query = "") {
      const currentTimestamp = new Date().getTime();
      this.lastManagerRequestTimestamp = currentTimestamp;
      this.isLoadingManagers = true;

      var data = {
        q: { name: query, is_manager: true, status: this.active },
      };

      if (this.filter.anoSafra && this.filter.anoSafra.id)
        data.q["anosafra_id"] = this.filter.anoSafra.id;

      try {
        const response = await this.$http.secured.get("/api/v1/users", { params: data })

        if (currentTimestamp < this.lastManagerRequestTimestamp) return;

        this.managers = response.data.users || [];
      } catch (error) {
        this.setError(error, "Something went wrong")
      } finally {
        this.isLoadingManagers = false;
      }
    },
    getChannels() {
      this.$http.secured
        .get(`/api/v1/channels/`)
        .then((response) => {
          this.channels = response.data;
        })
        .catch((error) => this.setError(error, "Something went wrong"));
    },
    async findSalesmen(query) {
      const currentTimestamp = new Date().getTime();
      this.lastSalesmenRequestTimestamp = currentTimestamp;

      this.isLoadingSalesmen = true;
      var data = {
        name_only: true,
        q: { is_salesman: true, status: this.active },
      };

      if (query)
        data.q["name"] = query;
      if (this.filter.anoSafra && this.filter.anoSafra.id)
        data.q["anosafra_id"] = this.filter.anoSafra.id;
        data["anosafra_id"] = this.filter.anoSafra.id;
      if (this.filter.manager && this.filter.manager.id)
        data.q["manager_id"] = this.filter.manager.id;

      try {
        const response = await this.$http.secured.get("/api/v1/users", { params: data })

        if (currentTimestamp < this.lastSalesmenRequestTimestamp) return;

        this.salesmen = response.data || [];
      } catch (error) {
        console.error("[findSalesmen] error getting salesman data", error)
      }
      this.isLoadingSalesmen = false;
    },
  },
  watch: {
    filter: {
      handler(val) {
        const filtro = {};

        // Transforming data to event response
        if (val.manager && val.manager.id) {
          filtro.manager_id = val.manager.id;
        }
        if (!this.currentUser.is_admin && this.currentUser.is_manager) {
          filtro.manager_id = this.currentUser.id;
        }
        if (val.salesman && val.salesman.id) {
          filtro.salesman_id = val.salesman.id;
        }
        if (val.branch && val.branch.id) {
          filtro.branch_id = val.branch.id;
        }
        if (val.channel && val.channel.id) {
          filtro.channel_id = val.channel.id;
        }
        if (val.anoSafra && val.anoSafra.id) {
          filtro.anosafra_id = val.anoSafra.id;
        }
        if (val.type && val.type.code) {
          filtro.salesman_type = val.type.code;
        }

        this.$emit("filter", filtro);
      },
      deep: true,
    },
    "filter.anoSafra": function () {
      if (this.$can("index", "user")) {
        this.findSalesmen("");
      }
      if (this.currentUser.is_admin) {
        this.getManagers();
      }
    },
    "filter.manager": function () {
      if (this.$can("index", "user")) {
        this.findSalesmen("");
      }
    },
  },
};
</script>
